import * as fromDatatype from "../../../../models/datatype-library";

export class DepositRegisterTxnLineSearchCriteriaDtoModel {
    limit: number;
    orderBy: string|boolean;
    order: string;
    calcTotalRecords?: boolean;
    
    txn_type: string;
    created_date_from?: fromDatatype.TimestampTzDatatypeInterface;
    created_date_to?: fromDatatype.TimestampTzDatatypeInterface;
    date_txn_from?: fromDatatype.TimestampTzDatatypeInterface;
    date_txn_to?: fromDatatype.TimestampTzDatatypeInterface;
  }
    